import { Outlet } from 'react-router-dom'
import ImpersonationBanner from '~/pages/components/ImpersonationBanner'
import StatsNoticeDialog from '~/pages/components/StatsNoticeDialog'

function Root() {
  return (
    <>
      <ImpersonationBanner />
      <Outlet />
      <StatsNoticeDialog />
    </>
  )
}

export default Root
